import { DEFAULT_SESSION_TTL } from "@/lib/consts/session";
import { v4 as uuidv4 } from 'uuid';

class SessionService {
    private sessionToken: string | null = null;
    private sessionTtl: number | null = null;
    private sessionId: string | null = null;

    initialize(sessionToken?: string) {
        this.sessionToken = sessionToken ?? null;
        this.sessionTtl = Date.now() + DEFAULT_SESSION_TTL;
        this.sessionId = uuidv4();
    }

    getSessionId() {
        return this.sessionId;
    }

    getSessionTtl() {
        return this.sessionTtl;
    }

    getSessionToken() {
        return this.sessionToken;
    }

    setSessionToken(sessionToken: string) {
        this.sessionToken = sessionToken;
    }

    setSessionId(sessionId: string) {
        this.sessionId = sessionId;
    }

    clear() {
        this.sessionToken = null;
        this.sessionTtl = null;
        this.sessionId = null;
    }
}

export default new SessionService();